import React from 'react';
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import '../../../static/styles/apiguide.scss';
import '../../../static/styles/dashboard.scss';

export default class ViewSingleOrderReservation extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const col_number_8 = 8;
        const total_levels = 6;
        const level1 = 5;
        const level2 = 4;
        const level2_prefix = level1 - level2;
        const level3 = 3;
        const level3_prefix = level1 - level3;
        const level4 = 2;
        const level4_prefix = level1 - level4;
        const level5 = 1;
        const level5_prefix = level1 - level5;
        return (
            <div id={"view-single-order-reservation"}>
                {/*<h3 className={"mb0 mt40"}>11. 주문 한건의 예약 데이터 API를 조회하기</h3>*/}
                <h3 className={"mb0 mt40"}>예약 단일 조회</h3>

                <div className="blog-post-meta">
                    <span className="s-post">주문 ID(orderID)로 판매된 상품의 예약을 조회 할 수 있습니다.</span>
                    <h3 className="request-method">
                        <span className="label label-success">GET</span>
                    </h3>
                </div>

                <div className="table-responsive">
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <td>Path</td>
                            <td>Example Endpoint</td>
                        </tr>
                        <tr>
                            <td>/v1/marketplace/reservations/{'{orderId}'}</td>
                            <td>
                                https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v1/marketplace/reservations/1234567890
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div className="table-responsive mt40">
                    <h4>Request Parameters</h4>
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th colSpan="4" className="bold">Request Header</th>
                        </tr>
                        <tr>
                            <th>Name</th>
                            <th>Required</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td>Request-Vendor-Id</td>
                            <td>O</td>
                            <td>String</td>
                            <td>벤더 아이디 요청</td>
                        </tr>
                        <tr>
                            <th colSpan="4" className="bold">Path Segment Parameter</th>
                        </tr>
                        <tr>
                            <th>Name</th>
                            <th>Required</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td>orderId</td>
                            <td>O</td>
                            <td>Long</td>
                            <td>주문 아이디</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div className="table-responsive mt40">
                    <h4>Response Specifications</h4>
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th colSpan={level1}>Name</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td colSpan={level1}>code</td>
                            <td>String</td>
                            <td>응답 코드</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>message</td>
                            <td>String</td>
                            <td>응답 메세지</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>data</td>
                            <td>responseDto</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>travelProductId</td>
                            <td>String</td>
                            <td>여행상품 id</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>travelItemId</td>
                            <td>String</td>
                            <td>Travel Item Id</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>travelRateId</td>
                            <td>String</td>
                            <td>Travel Rate Id</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>productDetailType</td>
                            <td>String</td>
                            <td>상품 상세 타입</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>checkInDate</td>
                            <td>String</td>
                            <td>CheckIn Date</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>checkOutDate</td>
                            <td>String</td>
                            <td>CheckOut Date</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>penaltyPrice</td>
                            <td>String</td>
                            <td>Penalty Price</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>arrivalTime</td>
                            <td>String</td>
                            <td>도착예정시간</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>roomRequest</td>
                            <td>String</td>
                            <td>객실요청사항</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>additionalInfo</td>
                            <td>String</td>
                            <td>업체 커스텀 필드</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>vendorItemPackageName</td>
                            <td>String</td>
                            <td>여행 상품명</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>vendorItemPackageId</td>
                            <td>String</td>
                            <td>벤더 아이템 패키지 아이디</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>vendorItemName</td>
                            <td>String</td>
                            <td>여행 상품 아이템명</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>vendorItemId</td>
                            <td>String</td>
                            <td>벤더 아이템 아이디</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>vendorId</td>
                            <td>String</td>
                            <td>Vendor Id</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>userPhoneNumber</td>
                            <td>String</td>
                            <td>유저 전화 번호r</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>userName</td>
                            <td>String</td>
                            <td>유저 이름</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>userEmail</td>
                            <td>String</td>
                            <td>유저 이메일</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>totalQuantity</td>
                            <td>Integer</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>ticketStatusType</td>
                            <td>Enum</td>
                            <td><table className="table table-striped">
                                <tbody>
                                <tr>
                                    <td>티켓 상태</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <th>Value</th>
                                    <th>Description</th>
                                </tr>
                                <tr>
                                    <td>CONFIRM_PENDING</td>
                                    <td>예약대기</td>
                                </tr>
                                <tr>
                                    <td>CONFIRMED</td>
                                    <td>예약확정</td>
                                </tr>
                                <tr>
                                    <td>CANCEL_RECEIPT</td>
                                    <td>취소접수</td>
                                </tr>
                                <tr>
                                    <td>CANCEL_PROCEEDING</td>
                                    <td>취소중</td>
                                </tr>
                                <tr>
                                    <td>CANCEL_COMPLETE</td>
                                    <td>취소완료</td>
                                </tr>
                                <tr>
                                    <td>USED</td>
                                    <td>발행완료</td>
                                </tr>
                                </tbody>
                            </table></td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>ticketNumber</td>
                            <td>String</td>
                            <td>티켓 번호</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>salePrice</td>
                            <td>BigDecimal</td>
                            <td>판매 가격</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>reservedAt</td>
                            <td>String</td>
                            <td>예약 일시</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>reservationModifiedAt</td>
                            <td>String</td>
                            <td>Reservation Update Time</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>reservationId</td>
                            <td>Long</td>
                            <td>Reservation Id</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>refundedAt</td>
                            <td>String</td>
                            <td>환불 일시</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>rateCategoryId</td>
                            <td>Long</td>
                            <td>RateCategory Id</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>purcahsedAt</td>
                            <td>String</td>
                            <td>구매 일시</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>productType</td>
                            <td>String</td>
                            <td>Product Type</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>productId</td>
                            <td>Long</td>
                            <td>프로덕트 아이디</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>orderId</td>
                            <td>Long</td>
                            <td>주문 아이디</td>
                        </tr>

                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>dailyInventoryPrices</td>
                            <td>List</td>
                            <td>&nbsp;</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level3}>price</td>
                            <td>BigDecimal</td>
                            <td>Price</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level3}>extraPrice</td>
                            <td>BigDecimal</td>
                            <td>Extra Price</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level3}>extraDepositPrice</td>
                            <td>BigDecimal</td>
                            <td>Extra Deposit Price</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level3}>discountedSalePrice</td>
                            <td>BigDecimal</td>
                            <td>Discounted Sale Price</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level3}>depositPrice</td>
                            <td>BigDecimal</td>
                            <td>Deposit Price</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level3}>date</td>
                            <td>BigDecimal</td>
                            <td>Date</td>
                        </tr>

                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>couponSrl</td>
                            <td>Long</td>
                            <td>Coupon Serial Number</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div className="table-responsive mt40">
                    <div className="panel panel-default">
                        <div className="panel-heading">
                            {/*<h3 className="panel-title">응답값 예시</h3>*/}
                            <a data-toggle="collapse" href = "#responseDto">Response Body Sample</a>
                        </div>
                        <div id = "responseDto" className = "panel-collapse collapse">
                            <div className="panel-body">
                    <pre className="ty01">
                        {`
{
    "code": 200,
    "message": "SUCCESS",
    "data": {
        "success": true,
        "results": [
            {
                "travelProductId": "3556206588123456789",
                "travelItemId": "355624954123456789",
                "travelRateId": "355626726123456789",
                "productDetailType": "HOTEL",
                "penaltyPrice": null,
                "arrivalTime": "",
                "roomRequest": "",
                "additionalInfo": null,
                "vendorItemPackageName": "주문진 위너스호텔",
                "vendorItemPackageId": 30000000539581,
                "vendorItemName": "스탠다드온돌(시티뷰) [룸온니6-11월특가]스탠다드온돌(시티뷰)",
                "vendorItemId": 70000005963974,
                "vendorId": "A00160447",
                "userPhoneNumber": "010-1234-5678",
                "userName": "abc",
                "userEmail": "test@naver.com",
                "totalQuantity": 1,
                "ticketStatusType": "USED",
                "ticketNumber": "6E0312-123456789",
                "salePrice": 68966.0,
                "reservedAt": "2021-02-21 00:00:00",
                "reservationModifiedAt": "2021-02-19 12:42:59",
                "reservationId": 12345678,
                "refundedAt": null,
                "rateCategoryId": 1234567,
                "purchasedAt": "2021-02-19 12:42:56",
                "productType": "ACCOMMODATION",
                "productId": 10000000570160,
                "orderId": 412345678890,
                "dailyInventoryPrices": [
                    {
                        "price": 68966.0,
                        "extraPrice": 0,
                        "extraDepositPrice": 0,
                        "discountedSalePrice": 68966.0,
                        "depositPrice": 61380,
                        "date": "2021-02-21"
                    }
                ],
                "couponSrl": 4123456789,
                "checkOutDate": "2021-02-22",
                "checkInDate": "2021-02-21"
            }
        ],
        "failMessage": null
    }
}
                        `}
                    </pre>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="table-responsive">
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th>HTTP CODE</th>
                            <th>message</th>
                            <th>설명</th>
                        </tr>
                        <tr>
                            <td>400</td>
                            <td>Bad request</td>
                            <td>요청 파라미터 값이 정확하지 않을 경우에 발생합니다</td>
                        </tr>
                        <tr>
                            <td>401</td>
                            <td>Unauthorized Error</td>
                            <td>잘못된 인증 정보</td>
                        </tr>
                        <tr>
                            <td>403</td>
                            <td>Forbidden Error</td>
                            <td>클라이언트 에서 인증을 제공하였으나 접속 허가를 받지 못했을 경우에 발생합니다.</td>
                        </tr>
                        <tr>
                            <td>410</td>
                            <td>The resource has been permanently deleted</td>
                            <td>리소스가 삭제되었을 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>412</td>
                            <td>Precondition failed</td>
                            <td>전제조건이 충족하지 않아 요청이 처리되지 않을 경우에 발생합니다</td>
                        </tr>
                        <tr>
                            <td>429</td>
                            <td>Too many requests</td>
                            <td>요청이 많을 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>504</td>
                            <td>API Gateway response timeout</td>
                            <td>API 게이트웨이 응답시간 초과할 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>521</td>
                            <td>API provider server has error</td>
                            <td>API 프로바이더 서버에 에러가 있을 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>524</td>
                            <td>API provider to API gateway connection response timeout</td>
                            <td>API 프로바이더에서 API 게이트웨이 연결 응답 시간 초과할 경우 발생합니다</td>
                        </tr>

                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./travel-developers-interface/src/main/client/apis/ReservationAndCancellation/ReservationAndRefundAPI/ViewSingleOrderReservation.jsx